export default "__VITE_ASSET__6xmxLn9a__"